import { z } from 'zod';

const GeometrySchema = z.object({
  type: z.literal('Point'),
  coordinates: z.tuple([z.number(), z.number()]),
});

const PropertiesSchema = z.object({
  osm_type: z.string(),
  osm_id: z.number(),
  osm_key: z.string(),
  osm_value: z.string(),
  type: z.string(),
  postcode: z.string().optional(),
  countrycode: z.string().optional(),
  name: z.string().optional(),
  country: z.string().optional(),
  state: z.string().optional(),
  county: z.string().optional(),
  city: z.string().optional(),
  district: z.string().optional(),
  locality: z.string().optional(),
  street: z.string().optional(),
  extent: z.array(z.number()).optional(), // bounding box
});

const FeatureSchema = z.object({
  type: z.literal('Feature'),
  properties: PropertiesSchema,
  geometry: GeometrySchema,
});

export const FeatureCollectionSchema = z.object({
  type: z.literal('FeatureCollection'),
  features: z.array(FeatureSchema),
});

export type PhotonFeatureCollection = z.infer<typeof FeatureCollectionSchema>;
export type PhotonFeature = z.infer<typeof FeatureSchema>;
